var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tool-webpage"},[_c('img',{staticClass:"field-webpage",class:{'scale-type':!_vm.media.ext_val_scaleType},attrs:{"src":require("@/assets/images/program/program_webpage_img.png.png"),"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }